import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/organizations/card/map/index.ts